<template>
  <div>
    <div class="p-3 card mb-3">
      <FccDescricaoDasOpcoes :vagas-reservadas="listaVagasReservadas" @importar="importar" />
      <FccAlteracoesVagasReservadas :alteracoes="alteracoes" />
    </div>
    <fccLocalDeProvaStatus :etapa="etapa" />
  </div>
</template>

<script>
import axios from 'axios'
import store from '../../../../store'
import { TP_ETAPA } from '../constantes'
import fccLocalDeProvaStatus from '../fccLocalDeProvaStatus.vue'
import FccDescricaoDasOpcoes from './fccDescricaoDasOpcoes.vue'
import FccAlteracoesVagasReservadas from './fccAlteracoesVagasReservadas.vue'

export default {
  components: {
    FccDescricaoDasOpcoes,
    FccAlteracoesVagasReservadas,
    fccLocalDeProvaStatus
  },
  data() {
    return {
      listaVagasReservadas: [],
      alteracoes: []
    }
  },
  computed: {
    configuracao() {
      return store.state.localDeProva.configuracao
    },
    idLocalConfig() {
      return this.configuracao.idlocalconfig
    },
    etapa() {
      return TP_ETAPA.VAGAS_RESERVADAS
    }
  },
  created() {
    this.carregaTexto(this.codeMensagem('C01'))
    this.listarVagasReservadas().then(() => this.listarAlteracoes().then(this.carregaTexto))
  },
  methods: {
    listarVagasReservadas() {
      return new Promise((resolve) => {
        axios
          .get(
            store.state.baseUrlLocalDeProva +
              `LocalExameProvaEspecial/LocalExameListaVagasEspeciais/${this.idLocalConfig}`,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(({ data }) => {
            this.listaVagasReservadas = data
            resolve()
          })
          .catch(this.setErrorSystem)
      })
    },
    listarAlteracoes() {
      return new Promise((resolve) => {
        axios
          .get(
            store.state.baseUrlLocalDeProva +
              `LocalExameProvaEspecial/ListaVagasEspeciaisTecnico/${this.idLocalConfig}`,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(({ data }) => {
            this.alteracoes = data
            resolve()
          })
          .catch(this.setErrorSystem)
      })
    },
    importar(dados) {
      const body = dados.map((item) => ({
        idLocalConfig: this.idLocalConfig,
        ordem: item.ordem,
        idCampo: item.idcampo,
        valor: item.valor,
        descricao: item.descricao,
        cdFuncionario: this.dadosUserSession.usuCdFuncionario
      }))

      this.callConfirm(`Tem certeza que deseja importar?`, '').then(() => {
        this.carregaTexto(this.codeMensagem('C01'))
        axios
          .post(
            store.state.baseUrlLocalDeProva +
              `LocalExameProvaEspecial/LocalExameImportacaoVagasEspeciais`,
            body,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(() => {
            this.listarVagasReservadas().then(() => this.listarAlteracoes().then(this.carregaTexto))
          })
          .catch(this.setErrorSystem)
      })
    },
    excluir() {
      //  Não possui endpoint
    }
  }
}
</script>